import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const LicensesService = {
    get: async (code) => axios.get(API_URL + "/licences/" + code).then(({data}) => data).catch((err) => { throw err }),

    generator: async (code, hash) => axios.put(API_URL + "/licences/" + code, {hash}).then(({data}) => data).catch((err) => { throw err }),

    verifyLicense: async (hash) => axios.post(API_URL + "/licences/verify-license", {hash}).then(({data}) => data).catch((err) => { throw err }),
};

export default LicensesService;